import { API } from "@/lib/api";

// Opens a printable QR sticker for a work-code (machine MCH-xxxx or order BKT-xxxx).
// The QR encodes the admin scan URL so a phone camera opens the right record.
export function printQr(code, label = "") {
  const token = localStorage.getItem("admin_token") || "";
  const scanUrl = `${window.location.origin}/admin/skann/${encodeURIComponent(code)}`;
  const imgSrc = `${API}/v1/admin/qr.png?data=${encodeURIComponent(scanUrl)}&auth=${encodeURIComponent(token)}`;
  const w = window.open("", "_blank", "width=420,height=560");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>QR ${code}</title>
    <style>
      body{font-family:Inter,Arial,sans-serif;text-align:center;padding:24px;color:#1a1a1a}
      .code{font-size:22px;font-weight:700;letter-spacing:1px;margin-top:12px}
      .label{font-size:14px;color:#555;margin-top:4px}
      .brand{font-size:12px;color:#888;margin-top:16px}
      img{width:280px;height:280px}
    </style></head>
    <body onload="setTimeout(function(){window.print()},300)">
      <img src="${imgSrc}" alt="QR ${code}" />
      <div class="code">${code}</div>
      <div class="label">${label || ""}</div>
      <div class="brand">Bergen Kaffemaskin- og Teknikk Service</div>
    </body></html>`);
  w.document.close();
}
